import { Container } from 'react-bootstrap';
import '../style/navs.css';
import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function Navs() {
    const[run,setrun]=useState(true);
    const navigate = useNavigate();
    const [activeLink, setActiveLink] = useState(""); // حالة لتخزين الرابط النشط
  
    const handleClick = (e, path) => {
      e.preventDefault(); // منع إعادة تحميل الصفحة
      setActiveLink(path); // تحديث المسار النشط
      navigate(path); // التنقل باستخدام React Router
    };

  return (
    <Container>
      <div className='Navs'>
        <div className='logo'>
          <div className='logo-icon'>
            <i class='fa-solid fa-broom'></i>
          </div>
          <div className='logo-content'>
            <h5>
              <span>lamar</span> reinigung
            </h5>
            <h6>Reinigungsunternehmen</h6>
          </div>
        </div>

        <div className={run ?'menu-slide active':'menu-slide'}>
        <i onClick={()=>{setrun(false)}} class="fa-solid fa-circle-xmark"></i>
              <div  onClick={(e) => handleClick(e, "/")}><a href='#' className='active'> Heim</a></div>
            
             <div onClick={(e) => handleClick(e, "/about")} > <a href='#'>Über uns</a></div>
          
              <div onClick={(e) => handleClick(e, "/service")}><a href='#'>Service</a></div>
          
          <div  onClick={(e) => handleClick(e, "/contact")}>    <a href='#'>Kontakt</a></div>
         
        </div>

        <div className='navs-links'>
          <ul>
          <li><a href="#" onClick={(e) => handleClick(e, "/")} className={activeLink === "/" ? "active" : ""}> Heim</a></li>
            <li><a href="#" onClick={(e) => handleClick(e, "/about")} className={activeLink === "/about" ? "active" : ""}>Über uns</a></li>
            <li><a href="#" onClick={(e) => handleClick(e, "/service")} className={activeLink === "/service" ? "active" : ""}>service</a></li>
            <li><a href="#" onClick={(e) => handleClick(e, "/contact")} className={activeLink === "/contact" ? "active" : ""}>Kontakt</a></li> 
          </ul>
        </div>
        <div className='navs-btn'>
          <button className='g-btn' onClick={(e) => handleClick(e, "/contact")}>Niemals</button>
        </div>
        <div className='menu-btn'>
          <i onClick={()=>{setrun(true)}} class='fa-solid fa-bars'></i>
        </div>
      </div>
    </Container>
  );
}
